import Action from 'lib/interfaces/Action';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

interface FeatureFlagsPayload {
  featureFlags: FeatureFlagsMap;
}
interface FeatureFlagsOverridePayload {
  featureFlagsOverrides: FeatureFlagsMap;
}

export type FeatureFlagsActions =
  | Action<FeatureFlagsActionType.SaveFeatureFlags, FeatureFlagsPayload>
  | Action<FeatureFlagsActionType.SaveOverrideFeatureFlags, FeatureFlagsOverridePayload>;

export enum FeatureFlagsActionType {
  SaveFeatureFlags = 'feature-flags/SAVE_FEATURE_FLAGS',
  SaveOverrideFeatureFlags = 'feature-flags/SET_OVERRIDE_FEATURE_FLAGS',
}

export function saveFeatureFlags(featureFlags: { [featureName: string]: boolean }) {
  return {
    payload: {
      featureFlags,
    },
    type: FeatureFlagsActionType.SaveFeatureFlags,
  };
}

export function saveOverrideFeatureFlags(featureFlags: { [featureName: string]: boolean }) {
  return {
    payload: {
      featureFlagsOverrides: featureFlags,
    },
    type: FeatureFlagsActionType.SaveOverrideFeatureFlags,
  };
}
